import { render, staticRenderFns } from "./ImageCreateServer.vue?vue&type=template&id=18ba881c&"
import script from "./ImageCreateServer.vue?vue&type=script&lang=js&"
export * from "./ImageCreateServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports